import axiosInstance from "../../../axios/axios";

export function getFonts() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/arabiccalligraphycompetitions/getcalligraphystyles`).then(response => {
            if (response.data?.status?.responseCode == "200") {
                const res = response?.data?.result ?? [];
                resolve(res ?? []);
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function getFontCompetitionDetails(id) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/arabiccalligraphycompetitions/GetArabicCalligraphyCompetitionById?id=${id}`).then(response => {
            if (response.data?.status?.responseCode == "200") {
                const res = response?.data?.result ?? {};
                resolve(res ?? {});
            }
            resolve({});
        }).catch(error => reject({}))
    })
}
export function submitFontCompetition(formData) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/arabiccalligraphycompetitions/arabiccalligraphycompetitionregistration`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            resolve(response);
        }).catch(error => reject(false))
    })
}